import * as React from "react";
import cx from "classnames";

import "./Box.css";

interface BoxProps {
  fullWidth?: boolean;
  fullContainer?: boolean;
  hasShadow?: boolean;
  className?: string;
  children?: any; // TODO: Be explicit with component type
}

const getBoxClass = ({
  className = "",
  fullWidth,
  hasShadow,
}: BoxProps): string =>
  cx("box", {
    [className]: className,
    w1270: !fullWidth,
    w100: fullWidth,
    shadow: hasShadow,
  });

const getBoxInnerClass = ({ fullContainer }: BoxProps): string =>
  cx("box__container", {
    "container-fluid": fullContainer,
    container: !fullContainer,
  });

const Box = ({ children, ...props }: BoxProps): JSX.Element => (
  <div className={getBoxClass(props)}>
    <div className={getBoxInnerClass(props)}>{children}</div>
  </div>
);

export default Box;



// WEBPACK FOOTER //
// ./src/components/Box.tsx